import React from "react";

export const HomeContext = React.createContext();